import CryptoJS from "crypto-js"; //引用AES源码js
var _$=["\x7a\x6b\x79\x76\x66\x6b\x72\x71\x66\x6b\x72\x76\x73\x77\x64\x73","\x66\x64\x67\x61\x67\x67\x6b\x67\x67\x68\x69\x7a\x68\x69\x73\x79"];
var key = CryptoJS.enc.Utf8.parse(_$[0]);
var iv = CryptoJS.enc.Utf8.parse(_$[1]);

//解密方法
export function Decrypt(decryptStr) {
  const decryptBase64Str = CryptoJS.enc.Base64.parse(decryptStr);
  const createCode = CryptoJS.lib.CipherParams.create({
    ciphertext: decryptBase64Str,
  });
  const decryptedData = CryptoJS.AES.decrypt(createCode, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData).toString();
  return decryptedStr;
}
//加密方法
export function Encrypt(word) {
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}